export const fetchDepartment = async ({ BeURL }) => {
    try {

        const res = await fetch(`${BeURL}/fetch-department`, {
            method: "GET",
            credentials: "include",
        });

        const data = await res.json();

        if (!res.ok || !data?.success) {
            throw new Error(data?.message || "Failed to fetch departments");
        }

        return data; // ✅ important

    } catch (err) {

        console.error("Fetch Department Error:", err);

        return {
            success: false,
            message: err.message || "Something went wrong",
        };
    }
};
